import { createRouter, createWebHistory } from 'vue-router'
import adminRoutes from './routes/adminRoutes'
import generalRoutes from './routes/generalRoutes'
import { useAuthStore } from '@/stores/authStore'
import { i18n } from '@/i18n'

const SUPPORTED_LOCALES = ['en', 'it', 'fr', 'de', 'es', 'pt', 'uk']

const routes = [
  ...adminRoutes,
  ...generalRoutes,
  { path: '/forbidden', name: 'ForbiddenPage', component: () => import('@/views/status/ForbiddenPage.vue') },
  { path: '/:pathMatch(.*)*', name: 'NotFoundPage', component: () => import('@/views/status/NotFoundPage.vue') },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach(async (to) => {
  // Set i18n locale from URL params (general routes with /:locale prefix)
  if (to.params.locale && SUPPORTED_LOCALES.includes(to.params.locale)) {
    i18n.global.locale.value = to.params.locale
    localStorage.setItem('locale', to.params.locale)
    localStorage.setItem('localeStoredAt', String(Date.now()))
  }

  // Redirect non-prefixed paths to locale-prefixed version
  if (
    to.name === 'NotFoundPage' &&
    !to.path.startsWith('/admin') &&
    !to.path.startsWith('/forbidden') &&
    !to.path.startsWith('/login')
  ) {
    const locale = localStorage.getItem('locale') || 'en'
    return to.path === '/' ? `/${locale}` : `/${locale}${to.path}`
  }

  const auth = useAuthStore()

  if (!to.meta.requiresAuth) return true

  try {
    if (
      auth.token &&
      (!auth.user || typeof auth.user !== 'object' || Object.keys(auth.user).length === 0) &&
      to.meta.requiresAuth
    ) {
      try {
        await auth.fetchMe()
      } catch (e) {
        console.error('[router.beforeEach] fetchMe failed:', e)
        return { name: 'LoginPage', query: { redirect: to.fullPath } }
      }
    }

    const isAuthenticated = !!auth.token

    if (to.meta.requiresAuth && !isAuthenticated) {
      return { name: 'LoginPage', query: { redirect: to.fullPath } }
    }

    if (
      isAuthenticated &&
      (!auth.user || typeof auth.user !== 'object' || Object.keys(auth.user).length === 0) &&
      to.meta.requiresAuth
    ) {
      try {
        await auth.fetchMe()
      } catch (e) {
        console.error('[router.beforeEach] fetchMe failed:', e)
        return { name: 'LoginPage', query: { redirect: to.fullPath } }
      }
    }

    if (to.meta.permission) {
      const allowed = auth.can(to.meta.permission) === true
      if (!allowed) return { name: 'ForbiddenPage' }
    }

    return true
  } catch (e) {
    console.error('[router.beforeEach] crashed:', e)
    return { name: 'LoginPage', query: { redirect: to.fullPath } }
  }
})

export default router
